var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-sidebar'),_c('app-navbar'),_c('div',{staticClass:"app--main-content"},[_c('v-container',{staticClass:"app--content-container",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }